"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importStar(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var DistrictsMixin_1 = __importDefault(require("../../mixins/request/DistrictsMixin"));
var request_1 = __importDefault(require("../../request"));
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var __ = window.$lang;
var TransferDetails = /** @class */ (function (_super) {
    __extends(TransferDetails, _super);
    function TransferDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "transfer-details";
        _this.currentDistrict = {};
        _this.transferDetails = "";
        return _this;
    }
    TransferDetails.prototype.onDistrictsChanged = function (districts) {
        if (districts.array.length > 0) {
            this.currentDistrict = districts.array[0];
        }
        else {
            this.currentDistrict = {};
        }
    };
    TransferDetails.prototype.onCurrentDistrictChanged = function (district) {
        if (district.id) {
            this.requestTransferDetails(district.id);
        }
        else {
            this.transferDetails = "";
        }
    };
    TransferDetails.prototype.created = function () {
        this.requestDistricts(-1);
    };
    TransferDetails.prototype.onDistrictChange = function (option) {
        this.currentDistrict = { id: option.value, name: option.name };
    };
    TransferDetails.prototype.requestTransferDetails = function (district_id) {
        var _this = this;
        request_1.default.district.transferDetails(district_id, function (transferDetails) {
            _this.transferDetails = transferDetails;
        });
    };
    TransferDetails.prototype.onUpdateTransferDetails = function () {
        var _this = this;
        if (!this.currentDistrict || !this.currentDistrict.id) {
            return;
        }
        request_1.default.district.updateTransferDetails(this.currentDistrict.id, this.transferDetails, function () {
            _this.$notification("success", __("Szczegóły przelewu zostały zapisane!"));
        });
    };
    __decorate([
        vue_property_decorator_1.Watch("districts")
    ], TransferDetails.prototype, "onDistrictsChanged", null);
    __decorate([
        vue_property_decorator_1.Watch("currentDistrict")
    ], TransferDetails.prototype, "onCurrentDistrictChanged", null);
    TransferDetails = __decorate([
        vue_class_component_1.default({ components: {
                DistrictSelect: DistrictSelect_vue_1.default,
                VButton: VButton_vue_1.default
            } })
    ], TransferDetails);
    return TransferDetails;
}(vue_class_component_1.mixins(DistrictsMixin_1.default)));
exports.default = TransferDetails;
